var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-main",class:{ 'is-blocked': _vm.isAppBlocked }},[_c('div',{class:{ 'fs-modal': !_vm.isInline, 'fs-inline': _vm.isInline }},[_c('router-view')],1),(!_vm.isInline)?_c('div',{staticClass:"fs-modal-overlay"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }